import { DataResponseHelpTicket, HelpTicket, HelpTicketCreateRequest, HelpTicketSearchRequest, HelpTicketUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { falconClients } from "../clients/falcon.client";

export class HelpTicketService {

    async createHelpTicket(data: HelpTicketCreateRequest): Promise<HelpTicket> {
        return falconClients.helpTickets.createHelpTicket({
            helpTicketCreateRequest: data,
        });
    }

    async updateHelpTicket(id: number, data: HelpTicketUpdateRequest): Promise<HelpTicket> {
        return falconClients.helpTickets.updateHelpTicket({
            id,
            helpTicketUpdateRequest: data,
        });
    }

    async searchHelpTickets(data: HelpTicketSearchRequest): Promise<DataResponseHelpTicket> {
        return falconClients.helpTickets.searchHelpTickets({
            helpTicketSearchRequest: data,
        });
    }

    async deleteHelpTicket(id: number): Promise<void> {
        return falconClients.helpTickets.deleteHelpTicketById({
            id,
        });
    }
}
